import React, { useEffect } from "react";
import {
  GetIntellipayWidget,
  PostIntellipayStoreSuccess,
} from "../services/PaymentService";
import { useAxiosInstance } from "../services/Interceptor";
import { toast } from "react-toastify";

const IntellipayStoreOnlyMode = (props) => {
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    loadIntelliPayScript();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const resetIntellipayWidget = () => {
    window.__intellipayWidgetLoaded = false;
  };

  const loadIntelliPayScript = async () => {
    try {
      const response = await GetIntellipayWidget(apiInstance);

      if (response.success && response.data) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(response.data);

        if (!document.documentElement.contains(fragment))
          document.documentElement.appendChild(fragment);

        if (window.intellipay) {
          window.intellipay.initialize();
          window.intellipay.setStoreOnly(true);
          window.intellipay.runOnApproval(async (response) => {
            const storeResponse = await PostIntellipayStoreSuccess(
              apiInstance,
              response.custid,
            );

            if (storeResponse.success) {
              setTimeout(() => {
                props.onRegistrationSuccess();
              }, 1500);

              toast.success("Payment details updated successfully!", {
                position: "top-right",
              });
            } else {
              toast.error("Failed to update payment details", {
                position: "top-right",
              });
            }
          });
          window.intellipay.runOnNonApproval((res) => {
            setTimeout(() => {
              props.onRegistrationSuccess();
            }, 1500);
            resetIntellipayWidget();
          });
          window.__intellipayWidgetLoaded = true;
        }
      } else {
        console.error("Failed to retrieve IntelliPay script from backend");
      }
    } catch (error) {
      console.error("Error loading IntelliPay script:", error);
    }
  };

  return (
    <div>
      <input
        className="ipayfield"
        data-ipayname="account"
        type="hidden"
        value={0}
      />
      <input
        className="ipayfield"
        data-ipayname="email"
        type="hidden"
        value={props.userEmail}
      />
    </div>
  );
};

export default IntellipayStoreOnlyMode;
